__turbopack_context__.v({
  "caveats": "dDnQTq_caveats",
  "chart-card": "dDnQTq_chart-card",
  "chart-controls": "dDnQTq_chart-controls",
  "chart-data": "dDnQTq_chart-data",
  "chart-editor": "dDnQTq_chart-editor",
  "coverage-grid": "dDnQTq_coverage-grid",
  "data-table": "dDnQTq_data-table",
  "document-header": "dDnQTq_document-header",
  "document-meta": "dDnQTq_document-meta",
  "document-pane": "dDnQTq_document-pane",
  "document-section": "dDnQTq_document-section",
  "document-summary": "dDnQTq_document-summary",
  "evidence-links": "dDnQTq_evidence-links",
  "eyebrow": "dDnQTq_eyebrow",
  "field-label": "dDnQTq_field-label",
  "inline-error": "dDnQTq_inline-error",
  "markdown": "dDnQTq_markdown",
  "notebook-change": "dDnQTq_notebook-change",
  "notebook-document": "dDnQTq_notebook-document",
  "period-label": "dDnQTq_period-label",
  "provenance": "dDnQTq_provenance",
  "section-actions": "dDnQTq_section-actions",
  "section-heading": "dDnQTq_section-heading",
  "section-number": "dDnQTq_section-number",
  "section-prose": "dDnQTq_section-prose",
  "series-fields": "dDnQTq_series-fields",
  "summary-input": "dDnQTq_summary-input",
  "title-input": "dDnQTq_title-input",
});
